// extracted by mini-css-extract-plugin
export default {"cls1":"WFMAyr9hVNw0TCQRyYgw","cls2":"iljmyS5mct17gfNoSNcg WFMAyr9hVNw0TCQRyYgw"};